module.exports = __webpack_public_path__ + "img/hardware.7ac5f716.svg";